/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-16 11:39:42
 * @LastEditors: qiankun 153087222@qq.com
 * @LastEditTime: 2023-03-30 11:25:01
 * @FilePath: \qcsdjyBigdataUI\src\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/tool/request";
//景区概述界面涉及接口
let SummayApi = {
  //销售方式
  getRevenueLevelTo(params) {
    return request({
      url: "/qdBigData/scenicBigData/getRevenueLevelTo",
      method: "get",
      params,
    });
  },
  //应急指挥
  emergencyCommand(params) {
    return request({
      url: "/qdBigData/scenicBigData/getEmergencyCommand",
      method: "get",
      params,
    });
  },
  //疫情检测数据
  epidemicDetection(params) {
    return request({
      url: "/qdBigData/scenicBigData/getEpidemicDetection",
      method: "get",
      params,
    });
  },
  //景区实时客流
  passengerFlow(params) {
    return request({
      url: "/qdBigData/scenicBigData/getPassengerFlow",
      method: "get",
      params,
    });
  },
  //营收数据分析
  revenueData(params) {
    return request({
      url: "/qdBigData/scenicBigData/getRevenueData",
      method: "get",
      params,
    });
  },
  //景区客流营收销量日统计数据
  revenueSales(params) {
    return request({
      url: "/qdBigData/scenicBigData/getRevenueSales",
      method: "get",
      params,
    });
  },
  //游客满意度数据分析
  satisfactionAnalysis(params) {
    return request({
      url: "/qdBigData/scenicBigData/getSatisfactionAnalysis",
      method: "get",
      params,
    });
  },
  //景区服务中间弹窗
  getEventsDetailsList(params){
    return request({
      url: "/qdBigData/ScenicService/getEventsDetailsList",
      method: "get",
      params,
    });
  },
  //景区服务
  scenicService(params) {
    return request({
      url: "/qdBigData/scenicBigData/getScenicService",
      method: "get",
      params,
    });
  },
  //门户网站
  webPortals(params) {
    return request({
      url: "/qdBigData/scenicBigData/getWebPortals",
      method: "get",
      params,
    });
  },
  //微信关注数
  weChatFollow(params) {
    return request({
      url: "/qdBigData/scenicBigData/getWeChatFollow",
      method: "get",
      params,
    });
  },
  //微博粉丝数
  weiboFans(params) {
    return request({
      url: "/qdBigData/scenicBigData/geWeiboFans",
      method: "get",
      params,
    });
  },
};
//景区客流
let PassengerFlowApi = {
  //入园分析
  admissionAnalysis(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getAdmissionAnalysis",
      method: "get",
      params,
    });
  },
  //已预售
  getPreSold(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPreSold",
      method: "get",
      params,
    });
  },
  //预约人数分析
  appointmentAnalysis(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getAppointmentAnalysis",
      method: "get",
      params,
    });
  },
  //未来七天预测
  getNextSevenCalculateData(params) {
    return request({
      url: "/qdBigData/calculate/getNextSevenCalculateData",
      method: "get",
      params,
    });
  },
  //景区实时客流专题分析
  monographicAnalysis(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getMonographicAnalysis",
      method: "get",
      params,
    });
  },
  //网约限量
  onlineAppointmentLimit(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getOnlineAppointmentLimit",
      method: "get",
      params,
    });
  },
  //停车场分析
  parkingLotAnalysis(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getParkingLotAnalysis",
      method: "get",
      params,
    });
  },
  //今日累计客流
  passengerFlowThisDay(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPassengerFlowOfTheDay",
      method: "get",
      params,
    });
  },
  //本月累计客流
  passengerFlowThisMonth(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPassengerFlowThisMonth",
      method: "get",
      params,
    });
  },
  //本年累计客流
  passengerFlowThisYear(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPassengerFlowThisYear",
      method: "get",
      params,
    });
  },
  //已预售
  preSold(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPreSold",
      method: "get",
      params,
    });
  },
  //接待分析
  receptionAnalysis(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getReceptionAnalysis",
      method: "get",
      params,
    });
  },
  //根据景区名获取客流趋势
  getPassengerStatistics(params) {
    return request({
      url: "/qdBigData/ScenicPassengerFlow/getPassengerStatistics",
      method: "get",
      params,
    });
  },
  //预测
  getPredData(params) {
    return request({
      url: "/qdBigData/forecast/getMostNewForecastRecords",
      method: "get",
      params,
    });
  },
};
//景区营销
let MarketingApi = {
  //各渠道日营收数据
  channelRevenueDay(params) {
    return request({
      url: "/qdBigData/marketing/channelRevenueDay",
      method: "get",
      params,
    });
  },
  //OTA销售top10
  OTASaleTop10(params) {
    return request({
      url: "/qdBigData/marketing/OTASaleTop10",
      method: "get",
      params,
    });
  },
  //OTC销售top10
  OTCSaleTop10(params) {
    return request({
      url: "/qdBigData/marketing/OTCSaleTop10",
      method: "get",
      params,
    });
  },
  //OTA二级页面（分析）
  OtaOtcColumnar(params) {
    return request({
      url: "/qdBigData/marketing/OtaOtcColumnar",
      method: "get",
      params,
    });
  },
  //ota三级页面(详情)
  getOtaOtcName(params) {
    return request({
      url: "/qdBigData/marketing/getOtaOtcName",
      method: "get",
      params,
    });
  },
  //当日实时营销数据(营收金额)
  realTimeMarketingMoney(params) {
    return request({
      url: "/qdBigData/marketing/realTimeMarketingMoney",
      method: "get",
      params,
    });
  },
  //当日实时营销数据(销售数据)
  realTimeSales1(params) {
    return request({
      url: "/qdBigData/marketing/realTimeSales",
      method: "get",
      params,
    });
  },
  //按游客类型的整体营收
  getTouristsAmount(params) {
    return request({
      url: "/qdBigData/marketing/getTouristsAmount",
      method: "get",
      params,
    });
  },
  //按项目的整体营收
  getProjectAmount(params) {
    return request({
      url: "/qdBigData/marketing/getProjectAmount",
      method: "get",
      params,
    });
  },
  //按渠道的整体营收
  getChannelAmount(params) {
    return request({
      url: "/qdBigData/marketing/getChannelAmount",
      method: "get",
      params,
    });
  },
  //按产品的整体营收
  getProductAmount(params) {
    return request({
      url: "/qdBigData/marketing/getProductAmount",
      method: "get",
      params,
    });
  },
  //按景区年的整体营收
  getTypeRevenueAnalysis(params) {
    return request({
      url: "/qdBigData/marketing/getTypeRevenueAnalysis",
      method: "get",
      params,
    });
  },
  //按景区的整体营收
  getPlaceNameAmount(params) {
    return request({
      url: "/qdBigData/marketing/getPlaceNameAmount",
      method: "get",
      params,
    });
  },
  //整体营收
  getAmount(params) {
    return request({
      url: "/qdBigData/marketing/getAmount",
      method: "get",
      params,
    });
  },
  //景区客流营收销量日统计数据
  revenueSaleDay(params) {
    return request({
      url: "/qdBigData/marketing/revenueSaleDay",
      method: "get",
      params,
    });
  },
  //当年景区客流营收营收销量全月度统计(销售金额)
  revenueSaleFullName(params) {
    return request({
      url: "/qdBigData/marketing/revenueSaleFullName",
      method: "get",
      params,
    });
  },
  //当年景区客流营收营收销量全月度统计(营收金额)
  revenueSaleFullTime(params) {
    return request({
      url: "/qdBigData/marketing/revenueSaleFullTime",
      method: "get",
      params,
    });
  },
  //景区客流营收销量月统计数据
  revenueSaleMonth(params) {
    return request({
      url: "/qdBigData/marketing/revenueSaleMonth",
      method: "get",
      params,
    });
  },
  //景区客流营收销量年统计数据
  revenueSaleYear(params) {
    return request({
      url: "/qdBigData/marketing/revenueSaleYear",
      method: "get",
      params,
    });
  },
};
//景区管理
let AdministerApi = {
  //中间疫情发热统计
  epidemicFever(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getEpidemicFever",
      method: "get",
      params,
    });
  },

  getEpidemicInspectionPort(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getEpidemicInspectionPort",
      method: "get",
      params,
    });
  },
  //中间疫情每月统计
  monthlyStatisticsOnEpidemic(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getMonthlyStatisticsOnEpidemic",
      method: "get",
      params,
    });
  },
  //寻根巡检
  patrolInspection(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getPatrolInspection",
      method: "get",
      params,
    });
  },
  //寻根巡检二级
  getPatrolInspectionTO(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getPatrolInspectionTO",
      method: "get",
      params,
    });
  },
  //寻根巡检三级
  getPatrolInspectionThree(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getPatrolInspectionThree",
      method: "get",
      params,
    });
  },
  //中间日累计筛查人数
  screeningDay(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getScreeningDay",
      method: "get",
      params,
    });
  },
  //中间月累计筛查人数
  screeningMonth(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getScreeningMonth",
      method: "get",
      params,
    });
  },
  //中间年累计筛查人数
  screeningYear(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getScreeningYear",
      method: "get",
      params,
    });
  },
  //指挥调度
  smartScheduling(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getSmartScheduling",
      method: "get",
      params,
    });
  },
  //厕所信息
  toiletInformation(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getToiletInformation",
      method: "get",
      params,
    });
  },
  //智慧厕所
  toiletSquat(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getToiletSquat",
      method: "get",
      params,
    });
  },
  //厕所客流日统计
  toiletTraffic(params) {
    return request({
      url: "/qdBigData/ScenicSpotManagement/getToiletTraffic",
      method: "get",
      params,
    });
  },
};
//景区服务
let ServiceApi = {
  //统计趋势
  statisticalTrends(params) {
    return request({
      url: "/qdBigData/ScenicService/getStatisticalTrends",
      method: "get",
      params,
    });
  },

  
  //各维度游客满意度评分
  dimensionSatisfaction(params) {
    return request({
      url: "/qdBigData/ScenicService/getDimensionSatisfaction",
      method: "get",
      params,
    });
  },
  //舆情分析-情绪占比
  emotionalRatio(params) {
    return request({
      url: "/qdBigData/ScenicService/getEmotionalRatio",
      method: "get",
      params,
    });
  },
  //中间事件统计
  eventStatistics(params) {
    return request({
      url: "/qdBigData/ScenicService/getEventStatistics",
      method: "get",
      params,
    });
  },
  //求助统计
  helpStatistics(params) {
    return request({
      url: "/qdBigData/ScenicService/getHelpStatistics",
      method: "get",
      params,
    });
  },
  //舆情采集渠道TOP10
  publicOpinionCollection(params) {
    return request({
      url: "/qdBigData/ScenicService/getPublicOpinionCollection",
      method: "get",
      params,
    });
  },
  //舆情分析-舆情风险指数
  publicOpinionRiskLndex(params) {
    return request({
      url: "/qdBigData/ScenicService/getPublicOpinionRiskLndex",
      method: "get",
      params,
    });
  },
  //统计占比
  statisticsProportion(params) {
    return request({
      url: "/qdBigData/ScenicService/getStatisticsProportion",
      method: "get",
      params,
    });
  },
  //游客服务趋势
  touristServiceTrends(params) {
    return request({
      url: "/qdBigData/ScenicService/getTouristServiceTrends",
      method: "get",
      params,
    });
  },
};
const api = {
  ...SummayApi,
  ...PassengerFlowApi,
  ...MarketingApi,
  ...AdministerApi,
  ...ServiceApi,
};
export default api;
